
export const NaoEncontrada = () =>{
    return(
        <h3>Error 404 - Não Encontrada</h3>
    )
}